import React, { useState, useEffect } from 'react';
import { FaShieldHalved, FaTruckFront, FaPeopleGroup, FaHandHoldingDollar, FaHeartPulse, FaHandshake, FaWhatsapp, FaInstagram } from "react-icons/fa6";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from "react-router-dom";
import 'swiper/css';
import 'swiper/css/pagination';
import { SiHonda, SiToyota, SiHyundai, SiNissan, SiBmw, SiMitsubishi, SiFord, SiSuzuki, SiSubaru, SiMercedes, SiMazda, SiJeep, SiVolkswagen, SiKia } from "react-icons/si";
import { Pagination, Autoplay } from 'swiper/modules';
import About from './about';
import Service from './service';
import Maps from './maps';
import axios from 'axios';
import Logo from '../assets/images/LOGO_BBYSHIN_2.webp';
import { TbPhone } from 'react-icons/tb';

export default function Home() {
    const [galleryData, setGalleryData] = useState([]);
    const [itemsToShow, setItemsToShow] = useState(3);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const carBrands = [SiHonda, SiToyota, SiHyundai, SiNissan, SiBmw, SiMitsubishi, SiFord, SiSuzuki, SiSubaru, SiMercedes, SiMazda, SiJeep, SiKia, SiVolkswagen];
    const image = [
        { image: '1.webp' },
        { image: '2.webp' },
        { image: '3.webp' },
        { image: '4.webp' },
        { image: '5.webp' },
        { image: '6.webp' },
        { image: '7.webp' },
        { image: '8.webp' }
    ];
    document.title = "BBYSHIN TOWING|Jasa Derek Mobil Jombang Kertosono Mojokerto";

    // Main API configuration
    const apiMain = "https://bbyshin-backend.onrender.com/api"; // Main API configuration


    useEffect(() => {
        fetchInstagramPosts();
    }, []);

    const fetchInstagramPosts = async () => {
        try {
            const response = await axios.get(`${apiMain}/instagram-feed`);
            const posts = response.data.posts; // Access the posts array from the response

            // Map the posts to extract the necessary data
            const formattedPosts = posts.map(post => ({
                id: post.instagramId,
                ...post.postData, // Spread the postData object
                article: post.article // Include the article object
            }));

            setGalleryData(formattedPosts); // Set the formatted data to galleryData
        } catch (error) {
            console.error("Error fetching Instagram data:", error);
            setGalleryData([]); // Set an empty array on error
        }
    };
    useEffect(() => {
        const handleResize = () => {
            setItemsToShow(window.innerWidth < 768 ? 1 : 3);
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-US', { month: 'short', year: 'numeric' }).format(date);
    };

    const latestGalleryData = galleryData
        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
        .slice(0, itemsToShow);

    return (
        <div id='main' className='flex flex-col gap-20 md:gap-0'>
            <section className='w-full h-[50vh] md:h-[45vh] lg:h-[60vh] xl:h-[75vh]'>
                <Swiper
                    slidesPerView={1}
                    spaceBetween={0}
                    autoplay={{
                        delay: 2000,
                    }}
                    centeredSlides={true}
                    modules={[Autoplay]}
                    className="mySwiper mySwiper1 w-full h-[50vh] md:h-[45vh] lg:h-[60vh] xl:h-[75vh] absolute"
                >
                    {image.map((item, idx) =>
                        <SwiperSlide key={idx}>
                            {!isMobile && (
                                <>
                                    <div className="absolute z-20 left-0 bg-gradient-to-l from-transparent to-black h-full w-full" />
                                    <img src={`image/towing/mobile/${item.image}`} alt={`Towing Service Image ${idx + 1}`} className='w-full h-full absolute -z-20 aspect-[16/9] object-cover' />
                                </>
                            )}
                            {isMobile && (
                                <>
                                <div className="absolute z-20 bottom-0 bg-gradient-to-t from-transparent to-black h-full w-full" />
                                <img src={`image/towing/mobile/${item.image}`} alt={`Mobile Towing Image ${idx + 1}`} className='w-full h-auto absolute -z-20' />
                                </>

                            )}
                        </SwiperSlide>
                    )}

                </Swiper>

                <div className='w-full h-full flex flex-col justify-center sm:gap-10 xl:gap-8 gap-6 pl-8 xl:pl-20 -translate-y-10 md:-translate-y-0'>
                    <div className='w-[40vh] md:w-[80vh] flex flex-col gap-2 sm:gap-8'>
                        <img src="image/headline_bby.webp" alt="Headline BBY" className='w-40 sm:w-60 lg:w-80 xl:w-96 h-auto' />
                        <h1 className='text-white text-xl sm:text-3xl lg:text-4xl xl:text-5xl font-extrabold w-[45vh] lg:w-[55vh] xl:w-[80vh]'>Layanan Towing Cepat dan Profesional 24 Jam</h1>
                    </div>
                <div className='flex flex-row w-72 md:w-96 md:gap-6 gap-2 items-center'>
                
                    {/* Tombol WhatsApp */}
                    <button className='w-auto flex justify-center items-center gap-2 bg-[#FCFC00] py-2 px-3 lg:py-4 lg:px-8 rounded-full text-sm md:text-md hover:bg-transparent border border-[#FCFC00] hover:text-[#FCFC00] duration-200'>
                        <a href="https://wa.me/6282288349889" className='font-bold'>
                            Hubungi Kami
                        </a>
                        <FaWhatsapp className='text-xl'/>
                    </button>
                
                    {/* Tombol Telepon */}
                    <button className='w-auto flex justify-center items-center gap-2 bg-[#FCFC00] py-2 px-3 lg:py-4 lg:px-8 rounded-full text-sm md:text-md hover:bg-transparent border border-[#FCFC00] hover:text-[#FCFC00] duration-200'>
                        <a href="tel:+6282288349889" className='font-bold'>
                            Telepon Sekarang
                        </a>
                        <TbPhone className='text-xl'/>
                    </button>
                
                </div>

                </div>
                {!isMobile && (
                    <div className="absolute -translate-y-20 sm:-translate-y-20 md:-translate-y-20 lg:-translate-y-24 xl:-translate-y-[155px] w-full z-20">
                        <svg className='w-full h-full fill-white' version="1.1" viewBox="0 0 2048 255" xmlns="http://www.w3.org/2000/svg">
                            <path transform="translate(0,7)" d="m0 0 2 3 4 11 7 10 8 8 13 8 16 6 10 2 12 1 798 1 20 4 14 5 14 7 13 9 14 12 41 41 14 11 13 8 15 7 18 5 14 2h921l12-3 11-6 10-9 7-9 10-19 7-21 6-28 3-21h1v203h-2048z" />
                        </svg>
                    </div>
                )}
                <img src={Logo} alt="BBYSHIN Logo" className='absolute -translate-x-0 xl:-translate-x-8 -translate-y-10 lg:-translate-y-20 right-0 z-50 w-full md:w-[380px] lg:w-[600px] xl:w-[700px] h-auto truck hidden md:block' />
            </section>
            <section className='flex justify-center md:justify-start translate-x-0 sm:translate-x-0 md:translate-x-6 lg:translate-x-6 xl:translate-x-20 gap-9 z-20 -translate-y-24 sm:-translate-y-16 md:-translate-y-10 lg:-translate-y-10 xl:-translate-y-20 w-full h-full px-8 md:px-0'>
                <div className='grid grid-cols-3 gap-4 sm:gap-8 w-full sm:w-full md:w-[380px] lg:w-[480px]  xl:w-[600px] h-full'>
                    <div className='w-full h-full bg-[#fcfc00c0] flex flex-col justify-center items-center py-4 px-3 rounded-2xl gap-3 shadow-md'>
                        <FaShieldHalved className='w-5 h-5 sm:w-8 sm:h-8' />
                        <p className='text-center font-bold text-sm sm:text-lg md:text-sm lg:text-md xl:text-lg'>Aman & Terpercaya</p>
                    </div>
                    <div className='w-full h-full bg-[#fcfc00c0] flex flex-col justify-center items-center py-4 px-3 rounded-2xl gap-3 shadow-md'>
                        <FaTruckFront className='w-5 h-5 sm:w-8 sm:h-8' />
                        <p className='text-center font-bold text-sm sm:text-lg md:text-sm lg:text-md xl:text-lg w-40 sm:w-full'>Unit Khusus</p>
                    </div>
                    <div className='w-full h-full bg-[#fcfc00c0] flex flex-col justify-center items-center py-4 px-3 rounded-2xl gap-3 shadow-md'>
                        <FaPeopleGroup className='w-5 h-5 sm:w-8 sm:h-8' />
                        <p className='text-center font-bold text-sm sm:text-lg md:text-sm lg:text-md xl:text-lg'>Profesional Terlatih</p>
                    </div>
                    <div className='w-full h-full bg-[#fcfc00c0] flex flex-col justify-center items-center py-4 px-3 rounded-2xl gap-3 shadow-md'>
                        <FaHandHoldingDollar className='w-5 h-5 sm:w-8 sm:h-8' />
                        <p className='text-center font-bold text-sm sm:text-lg md:text-sm lg:text-md xl:text-lg'>Harga Terjangkau</p>
                    </div>
                    <div className='w-full h-full bg-[#fcfc00c0] flex flex-col justify-center items-center py-4 px-3 rounded-2xl gap-3 shadow-md'>
                        <FaHeartPulse className='w-5 h-5 sm:w-8 sm:h-8' />
                        <p className='text-center font-bold text-sm sm:text-lg md:text-sm lg:text-md xl:text-lg'>Perawatan Sepenuh Hati</p>
                    </div>
                    <div className='w-full h-full bg-[#fcfc00c0] flex flex-col justify-center items-center py-4 px-3 rounded-2xl gap-3 shadow-md'>
                        <FaHandshake className='w-5 h-5 sm:w-8 sm:h-8' />
                        <p className='text-center font-bold text-sm sm:text-lg md:text-sm lg:text-md xl:text-lg'>Komitmen Terjamin</p>
                    </div>
                </div>
            </section>
            <section className='flex flex-col h-full min-h-[50vh] w-full gap-12 justify-center items-center py-16 '>
                <header className='w-full flex flex-col items-center gap-4'>
                    <h2 className="text-5xl md:text-7xl font-['PoppinsB'] text-center">KENDARAAN</h2>
                    <div className="w-24 h-1 bg-[#fcfc00c0]"></div>
                    <p className="text-gray-600 text-center max-w-2xl px-4">Kami menangani berbagai merek kendaraan dengan layanan profesional</p>
                </header>

                <div className='w-full max-w-7xl px-8'>
                    <Swiper
                        slidesPerView={4}
                        spaceBetween={30}
                        autoplay={{
                            delay: 1500,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            320: { slidesPerView: 2 },
                            640: { slidesPerView: 3 },
                            768: { slidesPerView: 4 },
                            1024: { slidesPerView: 5 },
                        }}
                        centeredSlides={true}
                        modules={[Autoplay]}
                        className="mySwiper"
                    >
                        {carBrands.map((BrandsIcon, index) => (
                            <SwiperSlide key={index}>
                                <div className='group flex items-center justify-center p-6'>
                                    <BrandsIcon className='w-16 h-16 md:w-24 md:h-24 opacity-40 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300' />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>
            <About />
            <div id='colorful-section'>
                <Service></Service>
                <section id='gallery' className='flex flex-col h-full w-full gap-10 justify-center items-center p-4 sm:p-8 bg-gradient-to-b from-[#ffe600e7] to-[#ffe600e7]  '>
                    <header className='w-full flex flex-col items-center gap-4'>
                        <h2 className="text-5xl md:text-7xl font-['PoppinsB'] text-center">HISTORY</h2>
                        <div className="w-24 h-1 bg-[#fcfc00c0]"></div>
                        <p className="text-gray-600 text-center max-w-2xl px-4">  Sejak berdiri, BBYSHIN telah membantu banyak pelanggan dengan layanan derek profesional,
                            memastikan kendaraan mereka sampai dengan aman ke tujuan.</p>
                    </header>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 max-w-7xl w-full">
                        {latestGalleryData.map((item) =>
                            <div key={item.id}
                                className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 cursor-pointer border border-[#fcfc0030]">
                                <Link to="gallery">
                                    <div className="relative">
                                        {item.media_type === 'VIDEO' ? (
                                           <img
                                           className="aspect-square object-cover w-full"
                                           src={item.thumbnail_url}
                                           alt="Instagram post"
                                       />
                                        ) : (
                                            <img
                                                className="aspect-square object-cover w-full"
                                                src={item.media_url}
                                                alt="Instagram post"
                                            />
                                        )}
                                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent h-16" />
                                    </div>
                                    <div className='p-4 sm:p-6'>
                                        <div className='flex justify-between items-center mb-3'>
                                            <span className='px-3 py-1 bg-[#FCFC00] rounded-full text-xs font-bold shadow-sm'>
                                                {item.media_type}
                                            </span>
                                            <span className='text-xs text-gray-600 font-medium'>
                                                {formatDate(item.timestamp)}
                                            </span>
                                        </div>
                                        <h3 className='font-semibold text-base line-clamp-2 text-gray-800'>
                                            {item.article.title}
                                        </h3>
                                    </div>
                                </Link>
                            </div>
                        )}
                    </div>
                    <Link to="/gallery">
                        <button className='bg-[#FCFC00] hover:bg-[#e6e600] px-6 py-2 rounded-full font-bold transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5'>
                            Lihat lebih banyak →
                        </button>
                    </Link>
                </section>

                <Maps />
            </div>
        </div>
    )
}

